import { colors } from '../../colors';
var imageGallery = {
  primaryColor: colors.equineSnow,
  bgColor: colors.equineIron,
  tileBgColor: colors.equineSnow,
  iconBgColor: colors.equineIron
};
export default imageGallery;